import { PayloadAction } from '@reduxjs/toolkit';

import { AppState } from 'editor/src/store/app/types';

const setPendingPrintAreasReducer = (state: AppState, { payload }: PayloadAction<AppState['pendingPrintAreas']>) => {
  state.pendingPrintAreas = payload;
};

export default setPendingPrintAreasReducer;
